export default {
  button: {
    fontFamily: '"Nunito", sans-serif !important',
  },
  h1: {
    fontWeight: 500,
    fontSize: 35,
    letterSpacing: '-0.24px',
    fontFamily: '"Nunito", sans-serif !important',
  },
  h2: {
    fontWeight: 500,
    fontSize: 29,
    letterSpacing: '-0.24px',
    fontFamily: '"Nunito", sans-serif !important',
  },
  h3: {
    fontWeight: 500,
    fontSize: 24,
    letterSpacing: '-0.06px',
    fontFamily: '"Nunito", sans-serif !important',
  },
  h4: {
    fontWeight: 500,
    fontSize: 20,
    letterSpacing: '-0.06px',
    fontFamily: '"Nunito", sans-serif !important',
  },
  h5: {
    fontWeight: 600,
    fontSize: 16,
    letterSpacing: '-0.05px',
    marginBottom: 8,
    fontFamily: '"Nunito", sans-serif !important',
  },
  h6: {
    fontWeight: 500,
    fontSize: 14,
    letterSpacing: '-0.05px',
    fontFamily: '"Nunito", sans-serif !important',
  },
  overline: {
    fontWeight: 500,
    fontFamily: '"Nunito", sans-serif !important',
  },
};
